import axios from 'axios';
import {
  CLASS_LIST_REQUEST,
  CLASS_LIST_SUCCESS,
  CLASS_LIST_FAIL,
  CLASS_USER_LIST_REQUEST,
  CLASS_USER_LIST_SUCCESS,
  CLASS_USER_LIST_FAIL,
  CLASS_DETAILS_REQUEST,
  CLASS_DETAILS_SUCCESS,
  CLASS_DETAILS_FAIL,
  CLASS_DELETE_SUCCESS,
  CLASS_DELETE_REQUEST,
  CLASS_DELETE_FAIL,
  CLASS_CREATE_REQUEST,
  CLASS_CREATE_SUCCESS,
  CLASS_CREATE_FAIL,
  CLASS_UPDATE_REQUEST,
  CLASS_UPDATE_SUCCESS,
  CLASS_UPDATE_FAIL,
  CLASS_CREATE_REVIEW_REQUEST,
  CLASS_CREATE_REVIEW_SUCCESS,
  CLASS_CREATE_REVIEW_FAIL,
  CLASS_TOP_REQUEST,
  CLASS_TOP_SUCCESS,
  CLASS_TOP_FAIL,
} from '../constants/classConstants';
import { logout } from './userActions';

export const listClasses = (
  keyword = '',
  pageNumber = ''
) => async dispatch => {
  try {
    dispatch({ type: CLASS_LIST_REQUEST });

    const { data } = await axios.get(
      `/api/classes?keyword=${keyword}&pageNumber=${pageNumber}`
    );

    dispatch({
      type: CLASS_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CLASS_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const listUserClasses = user => async (dispatch, getState) => {
  console.log(user);
  try {
    dispatch({ type: CLASS_USER_LIST_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(`/api/classes?user=${user}`, config);

    dispatch({
      type: CLASS_USER_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CLASS_USER_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const listClassDetails = id => async dispatch => {
  try {
    dispatch({ type: CLASS_DETAILS_REQUEST });

    const { data } = await axios.get(`/api/classes/${id}`);

    dispatch({
      type: CLASS_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CLASS_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const deleteClass = id => async (dispatch, getState) => {
  try {
    dispatch({
      type: CLASS_DELETE_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    await axios.delete(`/api/classes/${id}`, config);

    dispatch({
      type: CLASS_DELETE_SUCCESS,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (message === 'Not authorized, token failed') {
      dispatch(logout());
    }
    dispatch({
      type: CLASS_DELETE_FAIL,
      payload: message,
    });
  }
};

export const createClass = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: CLASS_CREATE_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.post(`/api/classes`, {}, config);

    dispatch({
      type: CLASS_CREATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (message === 'Not authorized, token failed') {
      dispatch(logout());
    }
    dispatch({
      type: CLASS_CREATE_FAIL,
      payload: message,
    });
  }
};

export const updateClass = classs => async (dispatch, getState) => {
  try {
    dispatch({
      type: CLASS_UPDATE_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.put(
      `/api/classes/${classs._id}`,
      classs,
      config
    );

    dispatch({
      type: CLASS_UPDATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (message === 'Not authorized, token failed') {
      dispatch(logout());
    }
    dispatch({
      type: CLASS_UPDATE_FAIL,
      payload: message,
    });
  }
};

export const createClassReview = (classId, review) => async (
  dispatch,
  getState
) => {
  try {
    dispatch({
      type: CLASS_CREATE_REVIEW_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    await axios.post(`/api/classes/${classId}/reviews`, review, config);

    dispatch({
      type: CLASS_CREATE_REVIEW_SUCCESS,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (message === 'Not authorized, token failed') {
      dispatch(logout());
    }
    dispatch({
      type: CLASS_CREATE_REVIEW_FAIL,
      payload: message,
    });
  }
};

export const listTopClasses = () => async dispatch => {
  try {
    dispatch({ type: CLASS_TOP_REQUEST });

    const { data } = await axios.get(`/api/classes/top`);

    dispatch({
      type: CLASS_TOP_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CLASS_TOP_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
